import { ItemCustomLink } from "@dto/customLinks.dto";
import { ColorUtil } from "src/util/ColorUtil";
import { GLOB } from "src/util/Glob";
import "./CustomLink.less";

const CustomLink = ({ url, color, label }: Omit<ItemCustomLink, 'item'>) => {
  const nUrl = GLOB.normalizeLinkUrl(url);
  return <a href={nUrl} target='_blank' rel={'noopener noreferrer'}
    className="xm-custom-link"
    style={{ background: color, color: ColorUtil.contrastText(color), padding: '0.125em 0.5em', borderRadius: '0.25em' }}>
    {label}
  </a>;
};

export default CustomLink;